import axios from 'axios'
import { ICommittee } from '../types/types'

export interface IRoleInCommittee {
	committee: ICommittee
	role: string
}

export const getAllCommittees = async (sl?: boolean): Promise<ICommittee[]> => {
	const response = await axios.get(`/committees?sl=${sl}`)
	return response.data
}

export const getUserCommittees = async (): Promise<IRoleInCommittee[]> => {
	const response = await axios.get('/user/committees')
	return response.data.committees
}

export const toggleAcceptsAdmissions = async (slug: string, sl?: boolean) => {
	const response = axios
		.put(`/committees/${slug}/accept-admissions`, {
			params: { sl: sl },
		})
		.then((response) => {
			return response.data.accepts_admissions
		})
	return response
}
